import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex gap-10 justify-content-between" }

import { inject, provide } from "vue";
import { VerificationStatusTypes } from "@/core/types/VerificationInfos";
import { Search } from "@element-plus/icons-vue";
import CommonTabs from "@/projects/tenant/components/CommonTabs.vue";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'jpHeader',
  setup(__props) {

const { t } = useI18n();
const isLoading = inject<any>("isLoading");
const criteria = inject<any>("criteria");
const search = inject<any>("search");
const reset = inject<any>("reset");

const tabsData = [
  {
    index: 0,
    label: t("status.pending"),
    status: VerificationStatusTypes.AwaitingReview,
  },
  {
    index: 1,
    label: t("status.awaitingIdVerify"),
    status: VerificationStatusTypes.AwaitingAddressVerify,
  },
  {
    index: 2,
    label: t("status.awaitingCodeVerify"),
    status: VerificationStatusTypes.AwaitingCodeVerify,
  },
  {
    index: 3,
    label: t("status.codeVerified"),
    status: VerificationStatusTypes.CodeVerified,
  },
  {
    index: 4,
    label: t("status.approved"),
    status: VerificationStatusTypes.Approved,
  },
  {
    index: 5,
    label: t("status.rejected"),
    status: VerificationStatusTypes.Rejected,
  },
  {
    index: 6,
    label: t("status.incomplete"),
    status: VerificationStatusTypes.Incomplete,
  },
  {
    index: 7,
    label: t("status.all"),
    status: null,
  },
];

provide("tabsData", tabsData);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CommonTabs),
    _createElementVNode("div", null, [
      _createVNode(_component_el_input, {
        class: "w-250px",
        modelValue: _unref(criteria).email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(criteria).email) = $event)),
        clearable: true,
        placeholder: "Email"
      }, {
        append: _withCtx(() => [
          _createVNode(_component_el_button, {
            icon: _unref(Search),
            onClick: _unref(search),
            loading: _unref(isLoading)
          }, null, 8, ["icon", "onClick", "loading"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "ms-4",
        type: "info",
        plain: "",
        onClick: _unref(reset),
        disabled: _unref(isLoading)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ])
  ]))
}
}

})